// extracted by mini-css-extract-plugin
export var fadeIn = "_25-0";